import {ZapleczeApi} from "../../../ZapleczeApi.ts";
import Profile from "../../../Model/Profile.ts";
import {GoodNewsActivityI} from "../model/GoodNewsActivityI.ts";
import {GoodNewsManageI} from "../model/GoodNewsManageI.ts";



export class GoodNews extends ZapleczeApi {

    public constructor(token: string, profile: Profile ) {
        super(token, profile);
    }

    public async getGoodPromotions(): Promise<GoodNewsManageI[]> {
        const url = this.getUrl() + '/api/v1/promotion/good-manage';
        try {
            return this.get<GoodNewsManageI[]>(url);
        } catch (error) {
            console.error('Error fetching good status types:', error);
            throw error;
        }
    }

    public async updateGoodPromotion(good: GoodNewsActivityI): Promise<GoodNewsManageI> {
        const url = this.getUrl() + '/api/v1/promotion/good-manage';
        try {
            return this.put<GoodNewsManageI>(url, good);
        } catch (error) {
            console.error('Error fetching good status types:', error);
            throw error;
        }
    }

    public async markGoodDeleted(goodId: number): Promise<void> {
        const url = this.getUrl() + '/api/v1/good/mark-deleted';
        try {
            this.patch<number>(url, goodId);
        } catch (error) {
            console.error('Error fetching good status types:', error);
            throw error;
        }
    }
}
